// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"7cb32185","491":"b664dfaa"}[chunkId] + ".css";
};